module.exports = __webpack_public_path__ + "img/l_sj.1c716f36.png";